var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slidebar',{attrs:{"autoClose":true,"extraLarge":true},on:{"closeMe":_vm.closeSlidebar}},[_c('h4',[_vm._v("Umsókn")]),_c('Application',{attrs:{"applicationSchoolId":_vm.applicationSchoolId,"slidebar":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }